import { useMemo } from 'react';
import { PendingUploadsMessage } from 'components/pending-uploads-message';
import UploadedImages, { IUploadedImagesProps } from '.';
import { IPostUploads, UploadStatusEnum } from 'redux-store/api/activity-feed';
import { IUploadedFilesData } from 'utils/types';

const hasStatus = (upload: IUploadedFilesData | IPostUploads): upload is IPostUploads => {
  return 'status' in upload;
};

export const UploadedImagesWithStatus = ({ uploads, ...rest }: IUploadedImagesProps) => {
  const { visibleUploads, hasPendingUploads } = useMemo(() => {
    const visibleUploads =
      uploads?.filter(
        (upload) =>
          !hasStatus(upload) ||
          (upload.status !== UploadStatusEnum.FAILED && upload.status !== UploadStatusEnum.PENDING)
      ) || [];

    const hasPendingUploads = uploads?.some(
      (upload) => hasStatus(upload) && upload.status === UploadStatusEnum.PENDING
    );

    return { visibleUploads, hasPendingUploads };
  }, [uploads]);

  return (
    <>
      {hasPendingUploads && <PendingUploadsMessage />}
      <UploadedImages uploads={visibleUploads} {...rest} />
    </>
  );
};
